import React, { useEffect, useState } from "react";
import { Button, Col, Form } from "reactstrap";
import { handleGetApis, handlePostApis } from "../../../service/Api";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import { Block, BlockHeadContent, BlockTitle } from "../../../components/Component";

const UpdateSocialLinkPage = () => {
  useEffect(() => {
    fetchData();
  }, []);
  const [sendData, setSendData] = useState({
    facebook: "",
    whatsapp: "",
    youtube: "",
    instagram: "",
  });
  const [initialData, setInitialData] = useState({
    facebook: "",
    whatsapp: "",
    youtube: "",
    instagram: "",
  });
  const fetchData = () => {
    const res = handleGetApis(`admin/get/sociallink`);
    res.then(function (result) {
      if (result) {
        const data = {
          facebook: result.data.data.facebook,
          whatsapp: result.data.data.whatsapp,
          youtube: result.data.data.youtube,
          instagram: result.data.data.instagram,
        };
        setSendData(data);
        setInitialData(data);
      }
    });
  };

  const handleUpdateInfo = (e) => {
    e.preventDefault();
    if (JSON.stringify(sendData) === JSON.stringify(initialData)) {
      alert("No changes have been made to the data.");
      return;
    }
    const res = handlePostApis(`admin/update/socaillink`, sendData);
    res.then(function (result) {
      if (result) {
        alert(result.data.message);
        fetchData();
      }
    });
  };
  return (
    <>
    <Head title="Social Link"></Head>
    <Content>
        <Block>
      <BlockHeadContent>
                           <BlockTitle page>Update Social Link</BlockTitle>
                         </BlockHeadContent>
        <div className="mt-4">
          <Form className="row gy-4">
            <Col md="12">
              <div className="form-group">
                <label className="form-label">Facebook</label>
                <input
                  value={sendData.facebook}
                  onChange={(e) => {
                    setSendData({ ...sendData, facebook: e.target.value });
                  }}
                  type="text"
                  placeholder="https://facebook.com/ryzhm"
                  className="form-control"
                />
              </div>
            </Col>
            <Col md="12">
              <div className="form-group">
                <label className="form-label">WhatsApp</label>
                <input
                  type="text"
                  value={sendData.whatsapp}
                  onChange={(e) => {
                    setSendData({ ...sendData, whatsapp: e.target.value });
                  }}
                  placeholder="WhatsApp number (e.g. 9876543210) or https://wa.me/…"
                  className="form-control"
                />
              </div>
            </Col>
            <Col md="12">
              <div className="form-group">
                <label className="form-label">Youtube</label>
                <input
                  type="text"
                  value={sendData.youtube}
                  onChange={(e) => {
                    setSendData({ ...sendData, youtube: e.target.value });
                  }}
                  placeholder="https://youtube.com/@ryzhm"
                  className="form-control"
                />
              </div>
            </Col>
            <Col md="12">
              <div className="form-group">
                <label className="form-label">Instagram</label>
                <input
                  type="text"
                  value={sendData.instagram}
                  onChange={(e) => {
                    setSendData({ ...sendData, instagram: e.target.value });
                  }}
                  placeholder="https://instagram.com/ryzhm"
                  className="form-control"
                />
              </div>
            </Col>
            <div style={{ marginTop: "2rem" }} className="form-group">
              <Button type="submit" color="primary" size="lg" className="btn-block" onClick={handleUpdateInfo}>
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </Block>
    </Content>
    </>
  );
};
export default UpdateSocialLinkPage;
